/**
 * ui.js — Navigazione wizard, helper DOM, componenti UI.
 * Dipende da: state.js, utils.js
 */

// ── Thank You Page ───────────────────────────────────────────────

function showThankYouPage() {
    const s    = BookingState;
    const c    = s.client;
    const opts = s.start_address_opts;

    const mapUrl = s.mapImageUrl || '';

    const retRow = s.reservation_type !== 'andata' && s.return_time
        ? `<div class="mt-1"><strong>Ritorno:</strong> ${formatDateLabel(s.return_date)} ore ${s.return_time}</div>`
        : '';

    const jolly     = opts.jolly  === 'si' ? 'Sì' : 'No';
    const sediaLbl  = opts.sedia  === 'si' ? (opts.sedia_type || 'Fornita') : 'No';

    const iconCell = (icon) => {
        const inner = icon.endsWith('.svg')
            ? `<img src="${icon}" width="18" height="18" alt="">`
            : `<i class="${icon} fs-6"></i>`;
        return `<div class="bg-light rounded-circle d-flex align-items-center justify-content-center me-3 text-primary-dark flex-shrink-0" style="width:36px;height:36px;">${inner}</div>`;
    };

    const main = document.querySelector('main');
    if (!main) return;

    main.innerHTML = `
    <div style="max-width:650px;width:100%;padding:0 20px;margin:0 auto;">

      <div class="text-center mb-5">
        <h2 class="fw-bold title-dark">Grazie<br><em>per averci scelto!</em></h2>
        <p class="text-muted mt-3">Gentile <strong>${c.name} ${c.lastname}</strong>,<br>di seguito i dettagli del servizio prenotato:</p>
      </div>

      <!-- Dati trasferimento -->
      <div class="content-box bg-white p-4 rounded-4 shadow-sm mb-4">
        <h5 class="fw-bold mb-4">Dati trasferimento</h5>

        <div class="d-flex align-items-start mb-3 pb-3 border-bottom">
          ${iconCell(APP_IMG_BASE+'icon/elements-2.svg')}
          <div>
            <div><strong>Servizio selezionato:</strong></div>
            <div>${reservationTypeLabel(s.reservation_type)}</div>
          </div>
        </div>

        <div class="d-flex align-items-start mb-3 pb-3 border-bottom">
          ${iconCell(APP_IMG_BASE+'icon/map-pinpoint-02.svg')}
          <div>
            <div><strong>Da:</strong> ${s.start_address || '—'}</div>
            <div class="mt-1"><strong>A:</strong> ${s.end_address || '—'}</div>
          </div>
        </div>

        <div class="d-flex align-items-start mb-3 pb-3 border-bottom">
          ${iconCell(APP_IMG_BASE+'icon/user-group-02.svg')}
          <div>
            <div><strong>${s.seat}</strong>: Passeggeri in carrozzina</div>
            <div class="mt-1"><strong>${s.seat_guest}</strong>: Accompagnatori</div>
          </div>
        </div>

        <div class="d-flex align-items-start mb-3 ${mapUrl ? 'pb-3 border-bottom' : ''}">
          ${iconCell(APP_IMG_BASE+'icon/elements.svg')}
          <div>
            <div><strong>Quando:</strong> ${formatDateLabel(s.start_date)}</div>
            <div class="mt-1"><strong>Orario:</strong> ${s.start_time || '—'}</div>
            ${retRow}
          </div>
        </div>

        ${mapUrl ? `<div class="rounded-3 overflow-hidden mb-3" style="height:180px;background:url('${mapUrl}') center/cover no-repeat;"></div>` : ''}

        <div class="d-flex align-items-start">
          ${iconCell(APP_IMG_BASE+'icon/note-edit.svg')}
          <div>
            <div class="fw-semibold mb-2">Note aggiuntive</div>
            <div><strong>Jolly:</strong> ${jolly}</div>
            <div class="mt-1"><strong>Carrozzina:</strong> ${sediaLbl}</div>
            <div class="mt-1"><strong>Metodo di pagamento:</strong> ${s.paymentMethodLabel || '—'}</div>
          </div>
        </div>
      </div>

      <!-- Dati cliente -->
      <div class="content-box bg-white p-4 rounded-4 shadow-sm mb-5">
        <h5 class="fw-bold mb-4">Dati cliente</h5>
        <div class="d-flex align-items-start">
          ${iconCell(APP_IMG_BASE+'icon/user-circle.svg')}
          <div>
            <div><strong>Nome:</strong> ${c.name}</div>
            <div class="mt-1"><strong>Cognome:</strong> ${c.lastname}</div>
            <div class="mt-1"><strong>Codice Fiscale:</strong> ${c.cf}</div>
            <div class="mt-1"><strong>Indirizzo:</strong> ${c.address || '—'}</div>
            <div class="mt-1"><strong>Cellulare:</strong> ${c.phone}</div>
            <div class="mt-1"><strong>Email:</strong> ${c.email}</div>
          </div>
        </div>
      </div>

    </div>`;

    window.scrollTo({ top: 0, behavior: 'smooth' });
    track('booking_thankyou_view', {
        reservation_type:   s.reservation_type,
        start_date:         s.start_date,
        payment_method:     s.paymentMethodLabel || '',
        total:              s.Summary?.total || '',
    });
}

// ── Navigazione step ────────────────────────────────────────────

function showTab(n) {
    const tabs = document.getElementsByClassName('wizard-step');
    for (let i = 0; i < tabs.length; i++) {
        tabs[i].style.display = 'none';
        tabs[i].classList.remove('active');
    }
    tabs[n].style.display = 'block';
    setTimeout(() => tabs[n].classList.add('active'), 10);

    if (n === 2) loadSummaryStep();

    updateStepIndicator(n);
}

function updateStepIndicator(n) {
    for (let i = 0; i <= 2; i++) {
        const circle = document.getElementById('circle-' + i);
        const label  = circle?.nextElementSibling;
        if (!circle) continue;
        const active = i === n;
        circle.classList.toggle('active', active);
        label?.classList.toggle('text-muted',       !active);
        label?.classList.toggle('text-primary-dark',  active);
    }
}

// ── Conferma indirizzi ──────────────────────────────────────────

// Tipi Google Places considerati "place specifici" → nessun warning anche senza numero civico
const _SAFE_PLACE_TYPES = new Set([
    'airport', 'train_station', 'bus_station', 'transit_station', 'ferry_terminal',
    'hospital', 'health', 'lodging', 'university', 'school', 'library',
    'establishment', 'premise', 'street_address', 'point_of_interest',
    'food', 'restaurant', 'bar', 'store', 'shopping_mall',
    'stadium', 'museum', 'church', 'place_of_worship',
    'tourist_attraction', 'spa', 'gym', 'pharmacy',
]);

// Tipi Google Places considerati "generici" (area/zona senza luogo preciso)
const _GENERIC_PLACE_TYPES = new Set([
    'route', 'locality', 'sublocality', 'sublocality_level_1', 'sublocality_level_2',
    'neighborhood', 'political', 'administrative_area_level_1', 'administrative_area_level_2',
    'administrative_area_level_3', 'country', 'postal_code', 'intersection',
    'natural_feature', 'park', 'parking', 'colloquial_area',
]);

function _isGenericAddress(address, types) {
    if (!address) return false;
    const t = types || [];
    // Un tipo "safe" basta per non essere generico
    if (t.some(x => _SAFE_PLACE_TYPES.has(x))) return false;
    // Ha un numero civico → indirizzo specifico
    if (/\b\d+\b/.test(address)) return false;
    // Se ha solo tipi generici, oppure nessun tipo riconosciuto → segnala
    return true;
}

function _addressRowHtml(iconFile, label, address, warn) {
    const bg     = warn ? 'style="background:#fff8e1;border:1px solid #fbbf24"' : 'class="bg-light"';
    const warnIc = warn ? ' <i class="fa-solid fa-triangle-exclamation" style="color:#f59e0b;font-size:.85em"></i>' : '';
    return `
      <div class="d-flex align-items-start gap-3 rounded-3 p-3 mb-2" ${bg}>
        <img src="${APP_IMG_BASE+'icon/'+iconFile}.svg" width="20" height="20" class="mt-1 flex-shrink-0" alt="">
        <div>
          <div class="small fw-bold text-muted mb-1">${label}${warnIc}</div>
          <div class="fw-medium">${address || '—'}</div>
        </div>
      </div>`;
}

let _addrConfirmResolve = null;

function _injectAddressConfirmModal() {
    if (document.getElementById('addressConfirmModal')) return;
    document.body.insertAdjacentHTML('beforeend', `
      <div class="modal fade" id="addressConfirmModal" tabindex="-1" aria-hidden="true"
           data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered" style="max-width:420px;margin:1rem auto">
          <div class="modal-content rounded-4 border-0 shadow">
            <div class="modal-header border-0 pb-0 px-4 pt-4">
              <h5 class="modal-title fw-bold" style="color:#0e1f3b">
                <i class="fa-solid fa-map-location-dot me-2"></i>Controlla gli indirizzi
              </h5>
            </div>
            <div class="modal-body px-4 py-3" id="addressConfirmBody"></div>
            <div class="modal-footer border-0 px-4 pb-4 d-flex gap-2">
              <button type="button" id="addressConfirmEdit"
                      class="btn btn-light rounded-3 py-2 px-3 fw-medium flex-grow-1">
                <i class="fa-solid fa-pen me-1"></i>Modifica
              </button>
              <button type="button" id="addressConfirmOk"
                      class="btn rounded-3 py-2 px-3 fw-medium text-white flex-grow-1"
                      style="background:#0e1f3b">
                Sì, sono corretti
              </button>
            </div>
          </div>
        </div>
      </div>`);

    const modalEl = document.getElementById('addressConfirmModal');
    document.getElementById('addressConfirmEdit').addEventListener('click', () => {
        bootstrap.Modal.getInstance(modalEl)?.hide();
        if (_addrConfirmResolve) { _addrConfirmResolve(false); _addrConfirmResolve = null; }
    });
    document.getElementById('addressConfirmOk').addEventListener('click', () => {
        bootstrap.Modal.getInstance(modalEl)?.hide();
        if (_addrConfirmResolve) { _addrConfirmResolve(true); _addrConfirmResolve = null; }
    });
    // Fallback: chiusura modal senza bottoni (es. Escape) → annulla
    modalEl.addEventListener('hidden.bs.modal', () => {
        if (_addrConfirmResolve) { _addrConfirmResolve(false); _addrConfirmResolve = null; }
    });
}

function confirmAddresses() {
    if (ENV.IS_TEST) return Promise.resolve(true);

    _injectAddressConfirmModal();

    return new Promise(resolve => {
        const startWarn = _isGenericAddress(BookingState.start_address, BookingState.start_address_types);
        const endWarn   = _isGenericAddress(BookingState.end_address,   BookingState.end_address_types);

        const warningBlock = (startWarn || endWarn) ? `
          <div class="d-flex align-items-start gap-2 rounded-3 p-3 mb-3" style="background:#fff8e1">
            <i class="fa-solid fa-triangle-exclamation mt-1 flex-shrink-0" style="color:#f59e0b"></i>
            <span class="small">L'indirizzo evidenziato sembra generico o privo di numero civico.
              <strong>Il conducente potrebbe avere difficoltà a localizzarti</strong>: assicurati
              che sia il punto di raccolta corretto oppure clicca <em>Modifica</em> per correggerlo.</span>
          </div>` : '';

        document.getElementById('addressConfirmBody').innerHTML = `
          <p class="text-muted small mb-3">Verifica che partenza e arrivo siano corretti prima di proseguire.</p>
          ${_addressRowHtml('map-pinpoint-01', 'Partenza', BookingState.start_address, startWarn)}
          ${_addressRowHtml('map-pinpoint-02', 'Arrivo',   BookingState.end_address,   endWarn)}
          ${warningBlock}`;

        _addrConfirmResolve = resolve;
        new bootstrap.Modal(document.getElementById('addressConfirmModal')).show();
    });
}

// nextPrev è async: chiamata da onclick="nextPrev(1)" nell'HTML
async function nextPrev(n) {
    if (n === 1 && currentTab === 0) {
        collectStep1();
        const err = Validators.step1();
        if (err) { alert(err); return; }
        if (!readyForTrack) {
            alert('Controllo disponibilità non completato. Verifica le date e attendi il risultato.');
            return;
        }
        const confirmed = await confirmAddresses();
        if (!confirmed) return;
        track('booking_step1_complete', {
            reservation_type: BookingState.reservation_type,
            start_date:       BookingState.start_date,
            start_address:    BookingState.start_address,
            end_address:      BookingState.end_address,
        });
    }
    if (n === 1 && currentTab === 1) {
        collectStep2();
        const err = Validators.step2();
        if (err) { alert(err); return; }
        track('booking_step2_complete', {
            reservation_type: BookingState.reservation_type,
            seat:             BookingState.seat,
            seat_guest:       BookingState.seat_guest,
        });
    }
    if (n === -1) {
        readyForSummary = false;
        readyForPayment = false;
    }
    currentTab += n;
    showTab(currentTab);
}

// Alias sincrono richiesto dall'attributo onclick originale nell'HTML
function validateStep1() {
    collectStep1();
    return Validators.step1() === null;
}

// ── Alert di stato (step 3) ─────────────────────────────────────

function showStatusAlert(msg, isError = true) {
    const el = document.getElementById('paymentStatusAlert');
    if (!el) return;
    el.className = isError
        ? 'mb-3 p-3 rounded-3 small bg-danger text-white'
        : 'mb-3 p-3 rounded-3 small bg-success text-white';
    el.textContent = msg;
    el.classList.remove('d-none');
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
}

// ── Contatori passeggeri (step 2) ───────────────────────────────

function increment(id) {
    const el  = document.getElementById(id + 'Input');
    const val = parseInt(el.value);
    const tot = parseInt(document.getElementById('carrozzinaInput').value)
              + parseInt(document.getElementById('accompagnatoriInput').value);
    if (val < 10 && tot < ENV.MAX_PASSENGERS_PER_VAN) el.value = val + 1;
}

function decrement(id) {
    const el  = document.getElementById(id + 'Input');
    const val = parseInt(el.value);
    if (val > 0) el.value = val - 1;
}

// ── Popola select orari (step 1) ────────────────────────────────

function populateTimes() {
    ['oraPartenza', 'oraRitorno'].forEach(selId => {
        const sel = document.getElementById(selId);
        if (!sel) return;
        sel.innerHTML = '<option value="" selected disabled>Seleziona</option>';
        for (let h = 0; h < 24; h++) {
            for (let m = 0; m < 60; m += 15) {
                const t = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
                sel.insertAdjacentHTML('beforeend', `<option value="${t}">${t}</option>`);
            }
        }
    });
}

// ── Logica UI tipo tratta ───────────────────────────────────────

function toggleAndataRitorno(value) {
    const labelData        = document.getElementById('labelData');
    const labelOrarioAnd   = document.getElementById('labelOrarioAndata');
    const dataRitornoCol   = document.getElementById('dataRitornoCol');
    const orarioRitornoCol = document.getElementById('orarioRitornoCol');
    const boxModalita      = document.getElementById('boxModalitaRitorno');
    const boxMultitratta   = document.getElementById('boxMultitratta');
    const otherBoxes       = document.querySelectorAll(
        '#step-0 .content-box:not(#boxMultitratta):not(#boxModalitaRitorno)'
    );
    const btnAvanti = document.querySelector('#step-0 .btn-avanti-dark');

    const availResult = document.getElementById('availabilityResult');

    if (value === 'Multitratta') {
        boxMultitratta?.classList.remove('d-none');
        boxModalita?.classList.add('d-none');
        otherBoxes.forEach(b => b.classList.add('d-none'));
        btnAvanti?.classList.add('d-none');
        if (availResult) { availResult.classList.add('d-none'); availResult.textContent = ''; }
    } else {
        boxMultitratta?.classList.add('d-none');
        otherBoxes.forEach(b => b.classList.remove('d-none'));
        btnAvanti?.classList.remove('d-none');

        if (value === 'Andata & Ritorno') {
            dataRitornoCol?.classList.remove('d-none');
            if (labelData) labelData.innerText = 'Data di andata';
            if (labelOrarioAnd) labelOrarioAnd.innerText = 'Orario di andata';
            orarioRitornoCol?.classList.remove('d-none');
            boxModalita?.classList.remove('d-none');
        } else {
            dataRitornoCol?.classList.add('d-none');
            if (labelData) labelData.innerText = 'Data';
            if (labelOrarioAnd) labelOrarioAnd.innerText = 'Orario';
            orarioRitornoCol?.classList.add('d-none');
            boxModalita?.classList.add('d-none');
        }
    }

    readyForTrack = false;
    triggerAvailabilityCheck();
}

function updateLabelOrarioRitorno(modalita) {
    const label = document.getElementById('labelOrarioRitorno');
    if (label) label.innerText = modalita === 'prestabilito'
        ? 'Orario di ritorno'
        : 'Orario di ritorno (indicativo)';
}

// ── Iniezione DOM — ID mancanti ─────────────────────────────────

function initDomIds() {
    const step0Selects = document.querySelectorAll('#step-0 select:not([id])');
    if (step0Selects[0]) step0Selects[0].id = 'tipologiaPartenza';
    if (step0Selects[1]) step0Selects[1].id = 'tipologiaArrivo';
    const textarea = document.querySelector('#step-1 textarea');
    if (textarea) textarea.id = 'noteAggiuntive';
}

// ── Iniezione DOM — widget disponibilità (step 1) ───────────────

function injectAvailabilityWidget() {
    if (document.getElementById('availabilityResult')) return;
    const box = document.getElementById('boxDataOra');
    if (!box) return;
    const div = document.createElement('div');
    div.id        = 'availabilityResult';
    div.className = 'd-none small mt-3 mb-1 px-1';
    box.insertAdjacentElement('afterend', div);

}

// ── Iniezione DOM — step 3 (fatturazione + Stripe + alert) ─────

function injectStep3Fields() {
    if (document.getElementById('step3-injected')) return;

    const html = `
    <div id="step3-injected">

      <!-- Prezzo e numero van -->
      <div class="content-box bg-white p-4 rounded-4 shadow-sm mb-3 d-none" id="priceBox">
        <div id="priceTotal" class="fw-bold fs-5 text-primary-dark"></div>
        <div id="priceVans"  class="text-muted small mt-1"></div>
        <div id="priceExtra" class="text-muted small mt-1"></div>
      </div>

      <!-- Dati fatturazione -->
      <div class="content-box bg-white p-4 rounded-4 shadow-sm mb-3" id="billingBox">
        <h5 class="fw-semibold mb-4">Dati fatturazione</h5>
        <div class="bg-light rounded-3 px-3 py-2 mb-3">
          <label class="form-label text-dark small fw-bold mb-0" style="margin-left:28px">Nome*</label>
          <div class="d-flex align-items-center mt-1">
            <!--<img src="${APP_IMG_BASE}icon/user-circle.svg" width="20" height="20" class="me-2 flex-shrink-0" alt="">-->
            <i class="fa-solid fa-circle-user text-muted me-2" style="width:20px;text-align:center;"></i>
            <input type="text" id="clientNome" class="form-control bg-transparent border-0 p-0 shadow-none" placeholder="Nome">
          </div>
        </div>
        <div class="bg-light rounded-3 px-3 py-2 mb-3">
          <label class="form-label text-dark small fw-bold mb-0" style="margin-left:28px">Cognome*</label>
          <div class="d-flex align-items-center mt-1">
            <!--<img src="${APP_IMG_BASE}icon/user-circle.svg" width="20" height="20" class="me-2 flex-shrink-0" alt="">-->
            <i class="fa-solid fa-circle-user text-muted me-2" style="width:20px;text-align:center;"></i>
            <input type="text" id="clientCognome" class="form-control bg-transparent border-0 p-0 shadow-none" placeholder="Cognome">
          </div>
        </div>
        <div class="bg-light rounded-3 px-3 py-2 mb-3">
          <label id="labelClientCF" class="form-label text-dark small fw-bold mb-0" style="margin-left:28px">Codice Fiscale*</label>
          <div class="d-flex align-items-center mt-1">
            <i class="fa-solid fa-id-card text-muted me-2" style="width:20px;text-align:center;"></i>
            <input type="text" id="clientCF" class="form-control bg-transparent border-0 p-0 shadow-none"
                   placeholder="RSSMRA80A01H501U" maxlength="16" style="text-transform:uppercase">
          </div>
        </div>
        <div class="bg-light rounded-3 px-3 py-2 mb-3">
          <label class="form-label text-dark small fw-bold mb-0" style="margin-left:28px">Indirizzo di residenza*</label>
          <div class="d-flex align-items-center mt-1">
            <i class="fa-solid fa-house text-muted me-2" style="width:20px;text-align:center;"></i>
            <input type="text" id="clientIndirizzo" class="form-control bg-transparent border-0 p-0 shadow-none" placeholder="Via Roma 1, Roma">
          </div>
        </div>
        <div class="bg-light rounded-3 px-3 py-2 mb-3">
          <label class="form-label text-dark small fw-bold mb-0" style="margin-left:28px">Email*</label>
          <div class="d-flex align-items-center mt-1">
            <i class="fa-regular fa-envelope text-muted me-2" style="width:20px;text-align:center;"></i>
            <input type="email" id="clientEmail" class="form-control bg-transparent border-0 p-0 shadow-none" placeholder="email@esempio.it">
          </div>
        </div>
        <div class="bg-light rounded-3 px-3 py-2 mb-3">
          <label class="form-label text-dark small fw-bold mb-0" style="margin-left:28px">Telefono*</label>
          <div class="d-flex align-items-center mt-1">
            <i class="fa-solid fa-phone text-muted me-2" style="width:20px;text-align:center;"></i>
            <input type="tel" id="clientTelefono" class="form-control bg-transparent border-0 p-0 shadow-none" placeholder="+39 333 1234567">
          </div>
        </div>
        <div class="form-check mt-2">
          <input class="form-check-input" type="checkbox" id="clientPrivacy">
          <label class="form-check-label small text-muted" for="clientPrivacy">
            Accetto l'<a href="${ENV.PRIVACY_URL}" target="_blank">Informativa sulla privacy</a> e i Termini e condizioni*
          </label>
        </div>
      </div>

    </div>`;

    const payBtns  = document.querySelector('#step-2 .d-flex.flex-column.gap-3');
    const btnPagaOra = document.querySelector('#step-2 .btn-avanti-dark:not(#btnConfirmStripe)');
    if (payBtns) {
        payBtns.insertAdjacentHTML('beforebegin', html);
        // stripeBox appare subito sotto il tasto "Paga ora", dentro il flex container
        if (btnPagaOra) {
            const stripeBoxHtml = ENV.USE_STRIPE_PAYMENT_ELEMENT
                ? `<div class="content-box bg-white p-4 rounded-4 shadow-sm d-none" id="stripeBox">
                     <h5 class="fw-semibold mb-3">Scegli il metodo di pagamento</h5>
                     <div id="stripe-payment-element"></div>
                     <div id="stripe-card-errors" class="text-danger small mt-2"></div>
                     <button type="button" id="btnConfirmStripe"
                             class="btn btn-avanti-dark w-100 py-2 rounded-3 fw-medium text-white mt-3">
                       Conferma pagamento
                     </button>
                   </div>`
                : `<div class="content-box bg-white p-4 rounded-4 shadow-sm d-none" id="stripeBox">
                     <h5 class="fw-semibold mb-3">Inserisci i dati della carta</h5>
                     <div id="stripe-card-element" class="bg-light rounded-3 p-3"></div>
                     <div id="stripe-card-errors" class="text-danger small mt-2"></div>
                     <button type="button" id="btnConfirmStripe"
                             class="btn btn-avanti-dark w-100 py-2 rounded-3 fw-medium text-white mt-3">
                       Conferma pagamento con carta
                     </button>
                   </div>`;
            btnPagaOra.insertAdjacentHTML('afterend', stripeBoxHtml);
        }
        payBtns.insertAdjacentHTML('afterend', `<div id="paymentStatusAlert" class="d-none mb-3"></div>`);
    }

    wireClientFields();
    initClientAddressAutocomplete();
    rewirePaymentButtons();

    // Precompila campi cliente da BookingState (attivo in IS_TEST e da hash params)
    const c = BookingState.client;
    [['clientNome', 'name'], ['clientCognome', 'lastname'], ['clientCF', 'cf'],
     ['clientIndirizzo', 'address'], ['clientEmail', 'email'], ['clientTelefono', 'phone']
    ].forEach(([id, key]) => {
        const el = document.getElementById(id);
        if (el && c[key]) el.value = c[key];
    });
    const privEl = document.getElementById('clientPrivacy');
    if (privEl && c.privacy === '1') privEl.checked = true;

    document.getElementById('btnConfirmStripe')
        .addEventListener('click', onStripeConfirm);

    // Payment Element: l'init avviene in onPayNow() perché serve l'importo;
    // Card Element classico: si pre-inizializza subito.
    if (!ENV.USE_STRIPE_PAYMENT_ELEMENT) {
        loadStripeJS(() => StripeController.init());
    }
}

function initClientAddressAutocomplete() {
    if (typeof google === 'undefined') return;
    const el = document.getElementById('clientIndirizzo');
    if (!el) return;
    const ac = new google.maps.places.Autocomplete(el, {
        types:  ['geocode'],
        fields: ['formatted_address', 'address_components'],
    });
    ac.addListener('place_changed', () => {
        const place = ac.getPlace();
        BookingState.client.address = place.formatted_address || el.value;
        el.value = BookingState.client.address;

        const countryComp = (place.address_components || [])
            .find(c => c.types.includes('country'));
        const countryCode = countryComp ? countryComp.short_name : 'IT';
        BookingState.client.address_country = countryCode;
        _updateCFLabel(countryCode === 'IT');
    });
    el.addEventListener('input', () => {
        BookingState.client.address         = '';
        BookingState.client.address_country = 'IT';
        _updateCFLabel(true);
    });
}

function _updateCFLabel(isItaly) {
    const lbl = document.getElementById('labelClientCF');
    if (lbl) lbl.textContent = isItaly ? 'Codice Fiscale*' : 'Codice Fiscale (opzionale)';
}

// Iniezione campi volo/treno/nave (solo per tratte turistiche)
function injectTuristicFields() {
    if (document.getElementById('turisticFields')) return;
    const billing = document.getElementById('billingBox');
    if (!billing) return;

    billing.insertAdjacentHTML('afterend', `
    <div id="turisticFields" class="content-box bg-white p-4 rounded-4 shadow-sm mb-3">
      <h5 class="fw-semibold mb-3">Info su voli/treni/navi (opzionale)</h5>
      <div class="bg-light rounded-3 px-3 py-2 mb-3">
        <label class="form-label text-dark small fw-bold mb-0" style="margin-left:28px">Numero volo</label>
        <div class="d-flex align-items-center mt-1">
          <i class="fa-solid fa-plane text-muted me-2" style="width:20px;text-align:center;"></i>
          <input type="text" id="flyNumber" class="form-control bg-transparent border-0 p-0 shadow-none" placeholder="Es. AZ1234">
        </div>
      </div>
      <div class="bg-light rounded-3 px-3 py-2 mb-3">
        <label class="form-label text-dark small fw-bold mb-0" style="margin-left:28px">Numero treno</label>
        <div class="d-flex align-items-center mt-1">
          <i class="fa-solid fa-train text-muted me-2" style="width:20px;text-align:center;"></i>
          <input type="text" id="trainName" class="form-control bg-transparent border-0 p-0 shadow-none" placeholder="Es. FR9342">
        </div>
      </div>
      <div class="bg-light rounded-3 px-3 py-2">
        <label class="form-label text-dark small fw-bold mb-0" style="margin-left:28px">Nome nave</label>
        <div class="d-flex align-items-center mt-1">
          <i class="fa-solid fa-ship text-muted me-2" style="width:20px;text-align:center;"></i>
          <input type="text" id="boatName" class="form-control bg-transparent border-0 p-0 shadow-none" placeholder="Nome nave">
        </div>
      </div>
    </div>`);

    document.getElementById('flyNumber') ?.addEventListener('input', e => { BookingState.fly_number = e.target.value; });
    document.getElementById('trainName') ?.addEventListener('input', e => { BookingState.train_name = e.target.value; });
    document.getElementById('boatName')  ?.addEventListener('input', e => { BookingState.boat_name  = e.target.value; });

    // Precompila da BookingState (attivo in IS_TEST)
    const fn = document.getElementById('flyNumber');  if (fn && BookingState.fly_number) fn.value = BookingState.fly_number;
    const tn = document.getElementById('trainName');  if (tn && BookingState.train_name) tn.value = BookingState.train_name;
    const bn = document.getElementById('boatName');   if (bn && BookingState.boat_name)  bn.value = BookingState.boat_name;
}
